import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const YoutubeModal = (props) => {
  const { url, closeYoutubeModal, customClass } = props;

  return (
    <div
      className={`modal bd-example-modal-lg playModal ${customClass ?? ""}`}
      id="myModal"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={closeYoutubeModal}
            >
              <span aria-hidden="true" />
            </button>
          </div>
          <div className="modal-body">
            <iframe
              id="link"
              src={url}
              allow="fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="youtube"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

YoutubeModal.propTypes = {
  url: PropTypes.string,
  closeYoutubeModal: PropTypes.func,
};

export default YoutubeModal;
